import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Recipient } from '../models/email-template/recipient';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuditLog } from '../models/audit-log/audit-log.interface';
import { TemplateRequest } from '../models/template/template-request.interface';

@Injectable({
  providedIn: 'root',
})
export class ResponsysService {
  private getHostUrl = () => {
    const url = environment.scheme + environment.host + environment.port + '/';
    return url;
  };

  private readonly recipientUrl = `${this.getHostUrl()}api/v${environment.version
    }/responsys/recipient`;

  private readonly recipientsUrl = `${this.getHostUrl()}api/v${environment.version
    }/responsys/recipients`;

  private readonly IsTemplateProcToResponsysUrl = `${this.getHostUrl()}api/v${environment.version
    }/Responsys/isTemplateProcToResponsys`;

  private readonly auditLogsUrl = `${this.getHostUrl()}api/v${environment.version
    }/responsys/auditLogs`;


  private readonly saveTemplateToResponsysUrl = `${this.getHostUrl()}api/v${environment.version
    }/Responsys/saveToResponsys`;



  constructor(private http: HttpClient) {
  }

  getAllRecipients(): Observable<any> {
    return this.http.get<any>(this.recipientsUrl);
  }

  IsTemplateProcToResponsys(templateName: string): Observable<any> {
    const params = new HttpParams().set('templateName', templateName);
    return this.http.get<any>(this.IsTemplateProcToResponsysUrl, { params });
  }

  addRecipient(recipient: Recipient): Observable<any> {
    return this.http.post<any>(this.recipientUrl, recipient);
  }

  deleteRecipient(customerId: string) {
    const params = new HttpParams().set('customerId', customerId);
    return this.http.delete<any>(this.recipientUrl, { params });
  }

  editRecipient(recipient: Recipient) {
    return this.http.put<any>(this.recipientUrl, recipient);
  }

  getAllAuditLogs(): Observable<AuditLog[]> {
    return this.http.get<AuditLog[]>(this.auditLogsUrl);
  }

  saveTemplateToResponsys(templateRequest: TemplateRequest): Observable<any> {
    return this.http.post<any>(this.saveTemplateToResponsysUrl, templateRequest);
  }
}
